import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { BackendService } from "../new-http/backend.service";
import { SuitabilityProfileResponse } from "../../models/suitability-santander/profile/suitability-profile.model";
import { SuitabilityProfileFittingRequest } from "../../models/suitability-santander/profile/suitability-profile-fitting-request.model";
import { SuitabilityProfileFittingResponse } from "../../models/suitability-santander/profile/suitability-profile-fitting-response.model";
import { SuitabilityProfileFittingAcceptRequest } from "../../models/suitability-santander/profile/suitability-profile-fitting-accept-request.model";
import { SuitabilityProfileFittingAcceptResponse } from "../../models/suitability-santander/profile/suitability-profile-fitting-accept-response.model";
import { ISuitabilityUserInvestorTypeResponse } from "../../interfaces/suitability-user-investor-type.interface";

@Injectable({ providedIn: 'root' })
export class SuitabilitySantanderService extends BackendService {
    private readonly baseUrl: string = '/oq/v1';

    /**
     * Busca informações do perfil a partir dos dados do cliente
     */
    public GetProfile(): Observable<SuitabilityProfileResponse> {
        return this.api.get<SuitabilityProfileResponse>(`${this.baseUrl}/profile`);
    }

    /**
     * Gera as informações do documento de desenquadramento
     */
    public GenerateProfileFitting(request: SuitabilityProfileFittingRequest): Observable<SuitabilityProfileFittingResponse>{
        return this.api.post<SuitabilityProfileFittingResponse>(`${this.baseUrl}/profile/fittings`, request);
    }

    /**
     * Aceite do termo de desenquadramento do cliente
     */
    public AcceptProfileFitting(request: SuitabilityProfileFittingAcceptRequest): Observable<SuitabilityProfileFittingAcceptResponse> {
        return this.api.post<SuitabilityProfileFittingAcceptResponse>(`${this.baseUrl}/profile/fittingAccept`, request);
    }

    /**
     * Obter tipo de investidor do usuário
     */
    public GetUserInvestorTypeSuitability() {
        return this.api.get<ISuitabilityUserInvestorTypeResponse>(`${this.baseUrl}/investor-self-declaration`);
    }
}
